import { request } from './_request.js';
import type {
  AssignProjectInput,
  AssignProjectResponse,
  AssignScopeSuggestionInput,
  AssignScopeSuggestionResponse,
} from '../../types/project-assign.js';

/**
 * 案件アサイン API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件アサイン（要件定義 / 開発）を実行する API クライアント
 * @graph-connects /projects/assign [calls, via:POST] 複数案件をまとめてアサインする
 * @graph-connects /projects/assign/scope-suggestions [calls, via:POST] 作らない成果物を AI に仮判断させる
 */
export const projectAssignApi = {
  /** 複数案件をまとめてアサインする（行ごとに成否が返る）。 */
  assign: async (payload: AssignProjectInput): Promise<AssignProjectResponse> =>
    request<AssignProjectResponse>('/projects/assign', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  /** 「作らない成果物」を AI に仮判断させる（何も保存しない。画面の初期値用）。 */
  suggestScope: async (
    payload: AssignScopeSuggestionInput,
  ): Promise<AssignScopeSuggestionResponse> =>
    request<AssignScopeSuggestionResponse>('/projects/assign/scope-suggestions', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
